import React, { useState, useCallback, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Grid, 
  Card,
  CardContent,
  FormControl,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Paper,
  Snackbar,
  Divider as MuiDivider,
  TextFieldProps
} from '@material-ui/core';

import { OndemandVideo } from '@material-ui/icons';

import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { spacing } from '@material-ui/system';
import {  KeyboardDatePicker } from '@material-ui/pickers';
import {DropzoneArea, DropzoneDialog} from 'material-ui-dropzone';
import { useDropzone } from 'react-dropzone';
import {isAndroid, isIOS} from 'react-device-detect';

import styled, {ThemeConsumer} from 'styled-components';

import DropZone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';

import { useUserListState } from '../../context/UserListContext';

import { Autocomplete } from '@material-ui/lab';
import {getSorting, stableSort} from '../../common/tableUtilities';
import { getSubjectFromParentEmail, getParentFromEmail } from '../../common/apiGetUtilities';
import { saveSubjectInfo, setUserInfo } from '../../common/apiSetUtilities';
import { calculateGestAgeFromExpected, prettifyMonthDay } from '../../common/dateTimeUtilities';
import { useUserListDispatch, UserListTypes } from '../../context/UserListContext';
import { convertUserDataToUserPropType } from '../../common/entityUtilities';
import {useUserState} from '../../context/UserContext';
import {  UserProps, AssessmentListUIProps, AssessmentPayloadProps, SubjectProps } from '../../common/entityUtilities';
import AsmtCreationProgressComponent from './components/AsmtCreationProgressComponent';
import { AssessmentSchemaProps, CpapUserSchemaProps, emptySubjectState, SubjectSchemaProps } from '../../common/mongoSchemas';
import { SaveStatusTypes } from '../../common/entityUtilities';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import useStyles from './styles';
import { useSubjectState } from '../../context/SubjectContext';
import { showAlert } from '../../common/utilities';
import { checkForStudyId } from '../../common/apiGetUtilities';
import {useTranslation} from 'react-i18next';
import RecordingModeSelector, { RecordingMode } from './components/RecordingModeSelector';
import GuidedRecordingContainer from './components/GuidedRecording/GuidedRecordingContainer';
// import { JSX } from 'react/jsx-runtime';
import { el } from 'date-fns/locale';
import { debugLog } from '../../common/debugUtilities';
const Divider = styled(MuiDivider)(spacing);
// const filter = createFilterOptions();

type NewAssessmentDialogProps = {
  isOpen:boolean,
  dialogComplete:()=>void,
  parentId: string,
  parentInformation:UserProps|null,
  asmtToEdit?:AssessmentListUIProps,
  subject?: SubjectProps
}

type NewAssessmentDialogValues = {
  email:string,
  dob: Date,
  duedate?: Date,
  asmtdate:Date|null, //default asmt date is CURRENT DATE
  notes:string,
  parentemail:string,
  parentId:string,
  gestAgeWeeks:number
};

const defaultState:NewAssessmentDialogValues = {
  email:'',
  dob: new Date('2020-08-20T00:00:00.000Z'),
  duedate: new Date('2020-08-20T00:00:00.000Z'),
  asmtdate:null,
  notes:'',
  parentemail:'',
  parentId:'',
  gestAgeWeeks:0
};


export default function NewAssessmentDialog(props:NewAssessmentDialogProps):JSX.Element {

  const {t, i18n} = useTranslation();

  const classes = useStyles();
  const disableDropZoneArea = true;
  //material-ui-dropzone was causing errors/crashes when uploading large video files
  //disabling it as of Dec 15 2022
  //react-dropzone-uploader module works fine and has worked fine on Android
  //So, both iOS and Android will use that module instead of material-ui-dropzone

  const userContext = useUserState();
  const {asmtToEdit, parentId, isOpen,  dialogComplete, subject} =props;
  const [isStudyIdValid, setStudyIdValid] = useState(false);
  const [selfStudyId, setSelfStudyId] = useState<string>('');
  const [parentInformation, setParentInformation] = useState<UserProps|null>(null);

  const [videos, setVideos] = React.useState<File[]>([]);
  // This is probably duplicating something, but i don't want to spend the
  // time to unravel things for now dlp
  const cribsyUser = useUserState();
  const { allUsers } = useUserListState();
  const [currentSelectedParent, setCurrentSelectedParent] = useState<UserProps | null>(null);
  const [currentSelectedSubject, setCurrentSelectedSubject] = useState<SubjectSchemaProps | null>(null);
  const [parentEmailForSearch, setParentEmailForSearch] = useState<string|null>('');
  const [subjectIdForSearch, setSubjectIdForSearch] = useState<string|null>('');
  // Study ID of the parent the admin selected (independent of the admin's own enrollment status).
  const [selectedParentStudyId, setSelectedParentStudyId] = useState<string>('');
  // Inline subject-creation fields, used by the admin path when the selected parent has no subject yet.
  const [newSubjectDob, setNewSubjectDob] = useState<Date|null>(null);
  const [newSubjectDueDate, setNewSubjectDueDate] = useState<Date|null>(null);
  const [newSubjectGestAgeDays, setNewSubjectGestAgeDays] = useState<number>(0);
  const [newSubjectGestAgeString, setNewSubjectGestAgeString] = useState<string>('');
  // True once we've confirmed (via API) that the selected parent has no subject record.
  const [selectedParentHasNoSubject, setSelectedParentHasNoSubject] = useState<boolean>(false);
  // Scenario B: admin adds a parent who has never logged in.
  const [manualParentMode, setManualParentMode] = useState<boolean>(false);
  const [manualParentEmail, setManualParentEmail] = useState<string>('');
  const [manualParentFirstName, setManualParentFirstName] = useState<string>('');
  const [manualParentLastName, setManualParentLastName] = useState<string>('');
  // Study ID looked up by typed manual email (for the enrollment indicator).
  const [manualParentStudyId, setManualParentStudyId] = useState<string>('');
  const userListDispatch = useUserListDispatch();
  const subjectFromContext = useSubjectState();
  const [dialogValue, setDialogValue] = React.useState(defaultState);
  const [hasSubject, setHasSubject] = useState(false);
  const [forUpdate, setForUpdate] = useState(false);
  const [savingStatus, setSavingStatus] = useState(SaveStatusTypes.INITIALIZE);
  const [asmtToSavePayload, setAsmtToSavePayload] = useState<AssessmentPayloadProps>();
  const [asmtReadyToSave, setAsmtReadyToSave] = useState(false);
  const [isCameraDialogVisible, setCameraDialogVisible] = useState(false);
  const [files, setFiles] = useState([]);
  const [dropzoneText, setDropzoneText] = useState(t('dropzonetext',{ns:'uploadvideo'}));

  const [toasterOpen, setToasterOpen] = useState(false);
  const [snackbarDuration, setSnackbarDuration] = useState(5000);
  const [toasterMessage, setToasterMessage] = useState('Requesting new assessment');
  const [datePickerIsOpen, setDatePickerOpen] = useState(false);

  // Guided recording state
  const [recordingMode, setRecordingMode] = useState<RecordingMode | null>(null);

  useEffect (()=>{
    // get parentInformation from parentId
    //
    setParentInformation(cribsyUser);
    debugLog('subject:', subjectFromContext);

  },[parentId]);

  // Reset recording mode when dialog opens
  useEffect(() => {
    if (isOpen) {
      setRecordingMode(null);
    }
  }, [isOpen]);

  useEffect (()=> {
    if (isIOS){
      setDropzoneText(t('dropzonetextios',{ns:'uploadvideo'}));
    }
    else if (isAndroid){
      setDropzoneText(t('dropzonetextandroid',{ns:'uploadvideo'}));
    }

  }, [isAndroid, isIOS]);

  useEffect( () => {
    debugLog('videos...:', videos?.length);
    if (videos.length > 0){
      setDropzoneText(t('fileadded',{ns:'uploadvideo'}));
      
    }
    else {
      setForUpdate(false);
      setDropzoneText(t('dropzonetext',{ns:'uploadvideo'}));
      if (isIOS){
        setDropzoneText(t('dropzonetextios',{ns:'uploadvideo'}));
      }
      else if (isAndroid){
        setDropzoneText(t('dropzonetextandroid',{ns:'uploadvideo'}));
      }
    }
  },[videos]);

  useEffect( ()=> {
    
    const setSubjectFromSearch = async ()=>{
    debugLog('The parent email;,', parentEmailForSearch);
    // Reset inline-subject-creation state on every parent change so stale values
    // from a previous selection don't leak into the new flow.
    setNewSubjectDob(null);
    setNewSubjectDueDate(null);
    setNewSubjectGestAgeDays(0);
    setNewSubjectGestAgeString('');
    setSelectedParentHasNoSubject(false);
    setSubjectIdForSearch(null);
    setCurrentSelectedSubject(null);

    if(parentEmailForSearch === null){
      setCurrentSelectedParent(null);
      setSelectedParentStudyId('');
      return;
    }

    const matchingParent = allUsers.find(user=>user.localEmail === parentEmailForSearch);
    debugLog('The matching parent ', matchingParent);
    if(matchingParent){

      setCurrentSelectedParent(matchingParent);


        if (cribsyUser.firebaseUser) {
          const subject = await getSubjectFromParentEmail(cribsyUser.firebaseUser, parentEmailForSearch);
          if (!subject || subject.length === 0) {
            debugLog('No subject found for parent email:', parentEmailForSearch);
            setSelectedParentHasNoSubject(true);
          }
          else {
            debugLog('Subject found:', subject[0]);
            setSubjectIdForSearch(subject[0]._id);
            setCurrentSelectedSubject(subject[0]);
            debugLog('asmtToEdit:', asmtToEdit);
          }

          // Look up the selected parent's Study ID so the admin sees a confirmation
          // (or "not enrolled" warning) before uploading on their behalf.
          try {
            const sid = await checkForStudyId(cribsyUser.firebaseUser, parentEmailForSearch);
            setSelectedParentStudyId(sid || '');
          } catch (err) {
            debugLog('Error checking study id for selected parent:', err);
            setSelectedParentStudyId('');
          }
        }


    }
  }
  setSubjectFromSearch();

  }, [parentEmailForSearch]);

  // Look up the Study ID for a manually-typed parent email so the enrollment
  // indicator updates as the admin types. Debounced to avoid hammering the API
  // on every keystroke.
  useEffect(() => {
    if (!manualParentMode) {
      setManualParentStudyId('');
      return;
    }
    const email = manualParentEmail.trim();
    if (!email || !cribsyUser.firebaseUser) {
      setManualParentStudyId('');
      return;
    }
    const handle = setTimeout(() => {
      checkForStudyId(cribsyUser.firebaseUser, email).then((sid) => {
        setManualParentStudyId(sid || '');
      }).catch((err) => {
        debugLog('Manual study id lookup failed:', err);
        setManualParentStudyId('');
      });
    }, 400);
    return () => clearTimeout(handle);
  }, [manualParentMode, manualParentEmail, cribsyUser.firebaseUser]);

  // Recompute Gest Age whenever the admin edits DOB/Due Date in the inline subject form.
  useEffect(() => {
    if (newSubjectDob && newSubjectDueDate) {
      const weekDays = calculateGestAgeFromExpected(newSubjectDueDate, newSubjectDob);
      if (weekDays.totalDays) {
        setNewSubjectGestAgeDays(weekDays.totalDays);
        if (i18n.language === 'en') {
          setNewSubjectGestAgeString(prettifyMonthDay(weekDays.weeks, weekDays.days, true));
        } else if (i18n.language === 'es') {
          setNewSubjectGestAgeString(
            weekDays.weeks + ' ' + t('weeks',{ns:'infantinfo'}) + ', ' +
            weekDays.days + ' ' + t('days',{ns:'infantinfo'})
          );
        }
      }
    } else {
      setNewSubjectGestAgeDays(0);
      setNewSubjectGestAgeString('');
    }
  }, [newSubjectDob, newSubjectDueDate, i18n.language]);

  useEffect ( () => {

    //debugLog('Cribsy User in new asmt:', cribsyUser);

    // the following line is not being called

    if(cribsyUser.localEmail){

      checkForStudyId(cribsyUser?.firebaseUser, cribsyUser.localEmail).then (
          (value) => {
            debugLog('Study Id:', value);
            setSelfStudyId(value || '');
            if (value !== ''){
              setStudyIdValid(true);
            }
            else {
              setStudyIdValid(false);
            }

          }
        ).catch ( (error)=>{
          debugLog('Error checking study id:', error);
          setSelfStudyId('');
          setStudyIdValid(false);
        })
    }

  }, [cribsyUser.localEmail]);


  // Interesting, seems like this gets called when the containing component
  // gets opened
  useEffect(()=>{
    if(asmtToEdit){
      debugLog('asmtToEdit data:', asmtToEdit);

      const updatedDialogValues:NewAssessmentDialogValues = {
        ...defaultState,
        parentemail: asmtToEdit.parent,
        notes: asmtToEdit.notes,
        asmtdate: asmtToEdit.date,
        dob: asmtToEdit.dob,
        duedate: subject?.duedate,
        parentId: asmtToEdit.parentId
      };
      const tempSubj = asmtToEdit.subject;
      setHasSubject(true);
      setForUpdate(true);
      setDialogValue({...dialogValue, ...updatedDialogValues});
      return;
    }

    
    // the parentinfo comes for the parent selectin/creation dialog
    // they are of type UserProps and comes for userListContext
    if(!parentInformation) return;
    const updatedDialogValues:NewAssessmentDialogValues = {
      ...defaultState,
      parentemail: parentInformation.localEmail!,
      parentId: parentInformation._id!
    };
    
    debugLog('[Subject]:', subject);
    if(subject){
      setHasSubject(true);
      if(subject?.dob){
        updatedDialogValues.dob = subject.dob;
      }
      updatedDialogValues.gestAgeWeeks = subject.gestage;
      updatedDialogValues.asmtdate = null; // let the user fill it in
      debugLog('[dialogValues]:', updatedDialogValues);
      debugLog('Cribsy User:', cribsyUser);
    }else{
      setHasSubject(false);
    }    
    setDialogValue({...dialogValue, ...updatedDialogValues});

  },[isOpen, asmtToEdit]);

  // Allow closing dialog even during upload - upload continues in background
  // with progress shown in header indicator
  const handleClose = () => {
    debugLog('Closing dialog (upload continues in background if active)');
    setHasSubject(false);
    setForUpdate(false);
    setDialogValue(defaultState);
    setSavingStatus(SaveStatusTypes.INITIALIZE);
    setRecordingMode(null); // Reset recording mode for next open
    setVideos([]); // Clear selected videos

    // Reset admin-flow state so a fresh open doesn't show stale Selected Parent /
    // inline subject form values from the previous session.
    setParentEmailForSearch(null);
    setCurrentSelectedParent(null);
    setSubjectIdForSearch(null);
    setCurrentSelectedSubject(null);
    setSelectedParentStudyId('');
    setSelectedParentHasNoSubject(false);
    setNewSubjectDob(null);
    setNewSubjectDueDate(null);
    setNewSubjectGestAgeDays(0);
    setNewSubjectGestAgeString('');
    setManualParentMode(false);
    setManualParentEmail('');
    setManualParentFirstName('');
    setManualParentLastName('');
    setManualParentStudyId('');

    dialogComplete();
  };

  const showTutorialVideo = () => {
    const url = (i18n.language=='en') ? 'https://youtu.be/jKOm49wJ9Aw': 
        'https://youtu.be/81fX677PoHM' ;
    debugLog('Opening tutorial video for language: ', i18n.language);
    window.open(url,'_blank');
   
  };

  const setVideoFromCapture = (video:any) => {
    debugLog('set video from capture');
    const videoSuffix = 1;
    let current_datetime = new Date();
    video.lastModifiedDate = current_datetime;
    let formatted_date = current_datetime.getFullYear() + '-' + (current_datetime.getMonth() + 1) + '-' + current_datetime.getDate() + ' ' + current_datetime.getHours() + ':' + current_datetime.getMinutes() + ':' + current_datetime.getSeconds(); 
    video.name = 'recording-' + formatted_date + '-' + videoSuffix;
    setVideos([video]);

  };

  const onDrop = useCallback( (acceptedFiles: React.SetStateAction<File[]>) => {
    setVideos(acceptedFiles);
  },[]);


  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});

  useEffect(()=>{
    // debugLog('Saving change', savingStatus);
    if(savingStatus === SaveStatusTypes.DONE){
      //To avoid oddities with users having assessments with videos
      //that don't belong to them clear out the selected video ids.
      handleClose();
    }
  },[savingStatus]);

  // const handleDropzoneUpload = async () => {
  //   // save all the files
  //   debugLog('Save all files', videos);
  // };



  const handleToasterClose = (event:any,reason:any) => {
    debugLog('toaster');
    if (reason === 'clickaway') {

      setToasterOpen(false);
      return;
    }
    setToasterOpen(false);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (videos && videos.length > 0){
      setToasterMessage(t('pleasewait',{ns:'uploadvideo'}));
      setToasterOpen(true);
      setSnackbarDuration(10000);
    }
    let localAssessor = userContext?.firebaseUser?.email;
    debugLog('[handleSubmit] for video upload');
    if(!userContext?.firebaseUser?.email || !subject?._id){
      // the user could have used phone auth, in which case firebaseUser won't have an email
      if (!userContext?.userId){
        debugLog('emmauser:', userContext?.userId);
        return;
      }
      else{
        debugLog('saving new asmt for:', userContext?.firebaseUser);
        localAssessor = userContext?.localEmail;
      }
      
    }
    // should be of type AssessmentPayloadProps
    const assessmentSavePayload:AssessmentPayloadProps = {
        date: dialogValue.asmtdate,
        subjectDueDate: dialogValue?.duedate,
        subjectId: subject?._id,
        notes: dialogValue.notes,
        // additionalProp1:{notes:dialogValue.notes},
        videosForUpload: videos,
        subjectDob: dialogValue.dob,
        parentEmail: dialogValue.parentemail
    };


    // Admin path: either (a) parent was picked from the autocomplete, or
    // (b) manual-parent mode is active (Scenario B — parent never logged in).
    // In case (b) we create the parent first; if their email already exists we
    // silently switch to "use existing parent" to avoid duplicates.
    if (cribsyUser.authLevel >= 5 && (currentSelectedParent || manualParentMode) && cribsyUser.firebaseUser) {
      let resolvedParent: UserProps | null = currentSelectedParent;

      if (manualParentMode) {
        const email = manualParentEmail.trim().toLowerCase();
        const firstname = manualParentFirstName.trim();
        const lastname = manualParentLastName.trim();
        if (!email || !firstname || !lastname) {
          debugLog('Manual parent form incomplete; aborting.');
          await showAlert(
            t('parentcreatefailtitle',{ns:'uploadvideo'}),
            t('parentformincomplete',{ns:'uploadvideo'}),
            t('ok',{ns:'uploadvideo'})
          );
          return;
        }

        try {
          // Dedupe: if the email already exists, reuse that record instead of POSTing a duplicate.
          const existing = await getParentFromEmail(cribsyUser.firebaseUser, email);
          if (existing && existing.length > 0) {
            debugLog('Manual parent email already exists; reusing record:', existing[0]);
            const existingProps = convertUserDataToUserPropType(existing[0]) as UserProps;
            // Make sure localEmail is populated so downstream code works.
            if (!existingProps.localEmail) existingProps.localEmail = email;
            resolvedParent = existingProps;
          } else {
            const newUserPayload: Partial<CpapUserSchemaProps> = {
              email,
              firstname,
              lastname,
              authLevel: 0,
              created: new Date()
            };
            const created = await setUserInfo(cribsyUser.firebaseUser, undefined, newUserPayload);
            debugLog('Manual parent created:', created);
            if (!created || !created.userId) {
              debugLog('Parent creation returned no userId; aborting upload.');
              await showAlert(
                t('parentcreatefailtitle',{ns:'uploadvideo'}),
                t('parentcreatefailmsg',{ns:'uploadvideo'}),
                t('ok',{ns:'uploadvideo'})
              );
              return;
            }
            const newParentProps = convertUserDataToUserPropType(created) as UserProps;
            // Backend returns Mongo _id either as userId or _id depending on shape;
            // normalize so subject creation has a parentid.
            if (!newParentProps._id && (created as any).userId) {
              newParentProps._id = (created as any).userId;
            }
            if (!newParentProps.localEmail) newParentProps.localEmail = email;
            resolvedParent = newParentProps;

            // Add the new parent to the in-memory autocomplete list so subsequent
            // admin actions can find them without a page reload.
            userListDispatch({ type: UserListTypes.ADD_USERS, allUsers: [newParentProps] });
          }
          setCurrentSelectedParent(resolvedParent);
        } catch (err) {
          debugLog('Parent creation/lookup failed:', err);
          await showAlert(
            t('parentcreatefailtitle',{ns:'uploadvideo'}),
            t('parentcreatefailmsg',{ns:'uploadvideo'}),
            t('ok',{ns:'uploadvideo'})
          );
          return;
        }
      }

      if (!resolvedParent || !resolvedParent._id) {
        debugLog('No resolved parent; aborting upload.');
        return;
      }

      // Subject resolution: reuse existing if available, else create from inline DOB/DueDate.
      let resolvedSubjectId = manualParentMode ? null : subjectIdForSearch;
      let resolvedSubjectDob = manualParentMode ? undefined : currentSelectedSubject?.dob;
      let resolvedSubjectDueDate = manualParentMode ? undefined : currentSelectedSubject?.duedate;

      // In manual mode, the parent record we just created/reused may already have a
      // subject from a prior admin action — check before creating a duplicate.
      if (manualParentMode && resolvedParent._id) {
        try {
          const existingSubjects = await getSubjectFromParentEmail(
            cribsyUser.firebaseUser, resolvedParent.localEmail || ''
          );
          if (existingSubjects && existingSubjects.length > 0) {
            debugLog('Reusing existing subject for re-resolved parent:', existingSubjects[0]);
            resolvedSubjectId = existingSubjects[0]._id;
            resolvedSubjectDob = existingSubjects[0].dob;
            resolvedSubjectDueDate = existingSubjects[0].duedate;
          }
        } catch (err) {
          debugLog('Error looking up subject for manual parent (continuing to create):', err);
        }
      }

      if (!resolvedSubjectId && newSubjectDob && newSubjectDueDate && cribsyUser.firebaseUser) {
        debugLog('[handleSubmit] Creating subject for parent before upload:', resolvedParent.localEmail);
        const subjectPayload: Partial<SubjectSchemaProps> = {
          dob: newSubjectDob,
          duedate: newSubjectDueDate,
          gestage: newSubjectGestAgeDays,
          parentid: resolvedParent._id
        };
        try {
          const created = await saveSubjectInfo(cribsyUser.firebaseUser, subjectPayload, undefined);
          debugLog('Subject created for parent:', created);
          if (created && created._id) {
            resolvedSubjectId = created._id;
            resolvedSubjectDob = created.dob || newSubjectDob;
            resolvedSubjectDueDate = created.duedate || newSubjectDueDate;
            // Reflect the new subject in local state so any subsequent UI relying on it is accurate.
            setSubjectIdForSearch(resolvedSubjectId);
            setCurrentSelectedSubject(created as SubjectSchemaProps);
            setSelectedParentHasNoSubject(false);
          } else {
            debugLog('Subject creation returned no _id; aborting upload to avoid an orphan.');
            await showAlert(
              t('subjectcreatefailtitle',{ns:'uploadvideo'}),
              t('subjectcreatefailmsg',{ns:'uploadvideo'}),
              t('ok',{ns:'uploadvideo'})
            );
            return;
          }
        } catch (err) {
          debugLog('Subject creation failed:', err);
          await showAlert(
            t('subjectcreatefailtitle',{ns:'uploadvideo'}),
            t('subjectcreatefailmsg',{ns:'uploadvideo'}),
            t('ok',{ns:'uploadvideo'})
          );
          return;
        }
      }

      if (!resolvedSubjectId) {
        // Belt-and-suspenders: should not reach here once the Save button gate is in place,
        // but if it does, fail loudly rather than upload to the admin's own UID.
        debugLog('No subject available for selected parent; aborting upload.');
        return;
      }

      assessmentSavePayload.parentEmail = resolvedParent.localEmail || '';
      assessmentSavePayload.subjectId = resolvedSubjectId;
      assessmentSavePayload.subjectDob = resolvedSubjectDob;
      assessmentSavePayload.subjectDueDate = resolvedSubjectDueDate;
    }

    debugLog('Asmt payload to save:', assessmentSavePayload);

    

    if(asmtToEdit){
      assessmentSavePayload.assessmentId = asmtToEdit.assessmentId;
    }
    
    setSavingStatus(SaveStatusTypes.SAVING);
    
    // Set the save payload, and let go since the 
    // the setter is connected AsmtCreationProgressCompoenent 
    // that does the upload
    
    setAsmtToSavePayload(assessmentSavePayload);
    setAsmtReadyToSave(true);
  };


  const handleDropZoneChangeStatus = ( meta:any, status:any) => {
    debugLog('Dropzone changestatus');
    debugLog('Status:',status);
    debugLog('Meta:',meta);
    debugLog('File:', meta.file);
    debugLog('File name:', meta.file.name);
    if (status == 'removed'){
      setVideos([]);
    }
    if (status == 'done'){
     let selected = [meta.file];
     debugLog('Setting selected video');
     setVideos(selected);
    }
  };

  // Guided recording handlers
  const handleModeSelected = (mode: RecordingMode) => {
    debugLog('[NewAssessmentDialog] Recording mode selected:', mode);
    setRecordingMode(mode);
  };

  const handleGuidedRecordingComplete = (videoFile: File) => {
    debugLog('[NewAssessmentDialog] Guided recording complete:', videoFile.name, videoFile.size);
    // Set the video file as if it was uploaded
    setVideos([videoFile]);
    // Reset to show the date entry step
    setRecordingMode(null);
  };

  const handleGuidedRecordingCancel = () => {
    debugLog('[NewAssessmentDialog] Guided recording cancelled');
    setRecordingMode(null);
  };

  return (     
    <Dialog
      aria-labelledby="form-dialog-title"
      onClose={handleClose} //closes on click away
      open={isOpen}
      fullScreen
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title">
            Create/update assessment
        </DialogTitle>
        <AppBar className={classes.paper}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" component="div">
              {t('title',{ns:'uploadvideo'})}
            </Typography>
                  
            <IconButton color="inherit"
              onClick={showTutorialVideo}
            >
              <OndemandVideo>

              </OndemandVideo>
            </IconButton>
           
          </Toolbar>
        </AppBar>
        <DialogContent className={classes.paper}>
            <Card  >
              <CardContent>

              <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12} sm={12} md={12}
            >
              {savingStatus===SaveStatusTypes.INITIALIZE?(
                <React.Fragment>
                  <DialogContentText
                    color="secondary"
                    variant="h6"
                  >
                  </DialogContentText>
                
                  <Grid container>
                    {(isIOS && !disableDropZoneArea) && 
                      <Grid item md={12} sm={12} xs={12}>
                        <DropzoneArea
                        maxFileSize={1000000000}
                        onChange={(files:any) => {
                          debugLog('Setting video file:',files);
                          debugLog('hasSubject:', hasSubject);
                          debugLog('SavingStatus:', savingStatus);
                          debugLog('Num videos:',videos.length);
                          debugLog('forUpdate:',forUpdate);


                          if(files && files.length > 0){
                            debugLog('Video file non null');
                            setVideos(files);
                          }
                        }}
                        //onChange for DropzoneArea component
                        dropzoneText={dropzoneText}
                        acceptedFiles={['video/*']}
                        showAlerts={true}
                        onAlert={(message:string) => {
                          debugLog('Message from dropzone:', message);
                        }}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        previewGridProps={{container: { spacing: 1, direction: 'row' }}}
                        onDrop={(files,event)=>{
                          debugLog('Event:',event);
                        }}
                        // showPreviewsInDropzone={true}
                        
                        />
                      </Grid>
                    }
                    { cribsyUser.authLevel >= 5  &&
                      <Grid  item md={12} sm={12} xs={12}>
                      <Card><CardContent>
                      <Grid item md={12} sm={12} xs={12}>
                        
                      
                        <Typography variant='h6' color='secondary'>
                          {t('selectparent',{ns:'uploadvideo'})}:
                          </Typography>
                        
                      </Grid>
                      <Grid item md={8} sm={8} xs={6}>
                        
                        <Autocomplete
                          autoHighlight
                          blurOnSelect
                          getOptionLabel={(option: { localEmail: any; })=> (option && option.localEmail)?option.localEmail:'unknown'}
                          // { // functionally equivalent, gads all this short hand
                          //   return (option && option.localEmail)?option.localEmail:'unknown';
                          // }}
                          handleHomeEndKeys
                          id="parent-email-selector"
                          onChange={(event: any, newValue: { localEmail: React.SetStateAction<string>; } | null) => {
                            debugLog('Selected parent:',newValue);
                            if(newValue && newValue.localEmail){
                              setParentEmailForSearch(newValue.localEmail as string | null);
                            }else{
                              setParentEmailForSearch(null);
                            }
                          }}
                          options={stableSort(allUsers,getSorting('asc','localEmail'))}
                          renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                            <TextField
                              {...params}
                              label={t('parentemail',{ns:'uploadvideo'})}
                              variant="outlined"
                            />
                          )}
                          selectOnFocus
                          style={{ width: 300 }}       
                        />
                        
                      </Grid>
                      
                      <Grid item md={4} sm={4} xs={6}>

                        <Typography variant='h6' color='secondary'>
                          {t('selectedparent',{ns:'uploadvideo'})}:
                        </Typography>
                        {currentSelectedParent?.localEmail}
                        {currentSelectedParent && (
                          <Typography
                            variant='body2'
                            style={{
                              marginTop: 4,
                              color: selectedParentStudyId ? '#2e7d32' : '#c62828',
                              fontWeight: 600
                            }}
                          >
                            {selectedParentStudyId
                              ? `${t('studyidconfirm',{ns:'uploadvideo'})}: ${selectedParentStudyId}`
                              : t('studyidnotfound',{ns:'uploadvideo'})}
                          </Typography>
                        )}
                      </Grid>

                      <Grid item md={12} sm={12} xs={12} style={{ marginTop: 8 }}>
                        <Button
                          variant='outlined'
                          color='primary'
                          size='small'
                          onClick={() => {
                            const next = !manualParentMode;
                            setManualParentMode(next);
                            if (next) {
                              // Entering manual mode: clear any prior autocomplete selection
                              // so the two paths don't conflict.
                              setParentEmailForSearch(null);
                              setCurrentSelectedParent(null);
                              setSubjectIdForSearch(null);
                              setCurrentSelectedSubject(null);
                              setSelectedParentStudyId('');
                              setSelectedParentHasNoSubject(false);
                            } else {
                              // Leaving manual mode: clear the form.
                              setManualParentEmail('');
                              setManualParentFirstName('');
                              setManualParentLastName('');
                              setNewSubjectDob(null);
                              setNewSubjectDueDate(null);
                            }
                          }}
                        >
                          {manualParentMode
                            ? t('manualparentcancel',{ns:'uploadvideo'})
                            : t('manualparenttoggle',{ns:'uploadvideo'})}
                        </Button>
                      </Grid>

                      {manualParentMode && (
                        <Grid item md={12} sm={12} xs={12} style={{ marginTop: 8 }}>
                          <Typography variant='body2' style={{ color: '#1565c0', marginBottom: 8 }}>
                            {t('manualparentinfo',{ns:'uploadvideo'})}
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item>
                              <TextField
                                required
                                label={t('parentemail',{ns:'uploadvideo'})}
                                type='email'
                                value={manualParentEmail}
                                onChange={(e) => setManualParentEmail(e.target.value)}
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                required
                                label={t('firstname',{ns:'uploadvideo'})}
                                value={manualParentFirstName}
                                onChange={(e) => setManualParentFirstName(e.target.value)}
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                required
                                label={t('lastname',{ns:'uploadvideo'})}
                                value={manualParentLastName}
                                onChange={(e) => setManualParentLastName(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {((currentSelectedParent && selectedParentHasNoSubject) || manualParentMode) && (
                        <Grid item md={12} sm={12} xs={12} style={{ marginTop: 12 }}>
                          <Typography variant='body2' style={{ color: '#c62828', marginBottom: 8 }}>
                            {t('nosubjectwarning',{ns:'uploadvideo'})}
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item>
                              <KeyboardDatePicker
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                format={i18n.language==='en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'}
                                label={t('dob',{ns:'infantinfo'})}
                                onChange={(date:Date|null) => setNewSubjectDob(date)}
                                value={newSubjectDob}
                              />
                            </Grid>
                            <Grid item>
                              <KeyboardDatePicker
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                format={i18n.language==='en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'}
                                label={t('duedate',{ns:'infantinfo'})}
                                onChange={(date:Date|null) => setNewSubjectDueDate(date)}
                                value={newSubjectDueDate}
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                disabled
                                label={t('gestage',{ns:'infantinfo'})}
                                value={newSubjectGestAgeString}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      </CardContent></Card>
                      </Grid>

                      

                    }

                    {/* Step 1: Show mode selector or recording/upload interface */}
                    {recordingMode === null && videos.length === 0 && (
                      <Grid item md={12} sm={12} xs={12}>
                        <RecordingModeSelector
                          onModeSelected={handleModeSelected}
                          guidedRecordingSupported={true}
                        />
                      </Grid>
                    )}

                    {/* Guided Recording Flow */}
                    {recordingMode === 'record' && (
                      <Grid item md={12} sm={12} xs={12}>
                        <GuidedRecordingContainer
                          infantDateOfBirth={currentSelectedSubject?.dob}
                          onComplete={handleGuidedRecordingComplete}
                          onCancel={handleGuidedRecordingCancel}
                        />
                      </Grid>
                    )}

                    {/* Upload Flow (traditional dropzone) */}
                    {recordingMode === 'upload' && videos.length === 0 && (
                      <>
                        {(isAndroid || isIOS) &&
                          <Grid item md={12} sm={12} xs={12}>
                            <Paper>
                              <Typography variant='h5' color='primary'>
                                {t('step1title',{ns:'uploadvideo'})}:
                              </Typography>
                              <Typography gutterBottom variant='body2'>
                                {dropzoneText}
                              </Typography>
                            </Paper>
                          </Grid>
                        }
                        {(isAndroid || isIOS) &&
                          <Grid item md={12} sm={12} xs={12}>
                            <DropZone
                              accept='video/*'
                              multiple={false}
                              maxFiles={1}
                              maxSizeBytes={1000000000}
                              onChangeStatus={handleDropZoneChangeStatus}
                              inputContent={t('step1text',{ns:'uploadvideo'})}
                            />
                          </Grid>
                        }
                        {/* what if it is a straight up browser? */}
                        {
                          !isAndroid && !isIOS &&
                          <Grid container>
                            <Grid item md={12} sm={12} xs={12}>
                              <Paper>
                                <Typography variant='h6' color='primary'>
                                  {t('step1title',{ns:'uploadvideo'})}:
                                </Typography>
                                <Typography gutterBottom variant='body2'>
                                  {dropzoneText}
                                </Typography>
                              </Paper>
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                            <DropZone
                              accept='video/*'
                              multiple={false}
                              maxFiles={1}
                              maxSizeBytes={1000000000}
                              onChangeStatus={handleDropZoneChangeStatus}
                            />
                          </Grid>
                        </Grid>
                        }
                      </>
                    )}

                    {/* Video Ready (from guided recording or upload) */}
                    {videos.length > 0 && (
                      <Grid item md={12} sm={12} xs={12}>
                        <Paper style={{ padding: 16, backgroundColor: '#e8f5e9' }}>
                          <Typography variant='h6' color='primary' style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <OndemandVideo />
                            {t('step1title',{ns:'uploadvideo'})}: ✓
                          </Typography>
                          <Typography variant='body1' style={{ marginTop: 8 }}>
                            Video ready: <strong>{videos[0].name}</strong>
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            Size: {(videos[0].size / 1024 / 1024).toFixed(2)} MB
                          </Typography>
                          <Button
                            variant='outlined'
                            color='secondary'
                            size='small'
                            style={{ marginTop: 8 }}
                            onClick={() => setVideos([])}
                          >
                            Remove Video
                          </Button>
                        </Paper>
                      </Grid>
                    )}
                   
                  </Grid>
                </React.Fragment>
              ):(

                <AsmtCreationProgressComponent
                  asmtSaveValues={asmtToSavePayload}
                  // closeParent={handleClose}
                  setSavingStatus={setSavingStatus}
                />
              )}             
            </Grid>

            <Grid item justify='flex-end'>
             
             <Button
               variant='contained'
               color = 'secondary'
               type='submit'
               disabled={(() => {
                 // Always-required gates.
                 if (savingStatus === SaveStatusTypes.SAVING) return true;
                 if (videos.length === 0) return true;
                 if (dialogValue?.asmtdate == null) return true;

                 // Admin Scenario B: manual parent entry. Require email + first + last
                 // names AND DOB + Due Date before allowing submission. The handler
                 // will create the parent and the subject before uploading.
                 if (cribsyUser.authLevel >= 5 && manualParentMode) {
                   const haveParentFields =
                     manualParentEmail.trim() !== '' &&
                     manualParentFirstName.trim() !== '' &&
                     manualParentLastName.trim() !== '';
                   if (haveParentFields && newSubjectDob && newSubjectDueDate) return false;
                   return true;
                 }

                 // Admin uploading on behalf of an existing parent (Scenario A):
                 // allow when either an existing subject was found OR DOB+Due Date
                 // are filled in for inline subject creation.
                 const adminUploadForParent =
                   cribsyUser.authLevel >= 5 && currentSelectedParent != null;
                 if (adminUploadForParent) {
                   if (subjectIdForSearch) return false;
                   if (newSubjectDob && newSubjectDueDate) return false;
                   return true;
                 }

                 // Regular user (or admin without a selected parent): unchanged behavior.
                 return !hasSubject;
               })()}
             >
               {forUpdate?t('update',{ns:'uploadvideo'}): t('save',{ns:'uploadvideo'})}
             </Button>
           </Grid>

            <Grid item xs={12}>
              { (dialogValue?.asmtdate == null && videos.length > 0)  ? (
                <Typography variant="h6" color="primary">
                 {t('step2alt',{ns:'uploadvideo'})}.
                </Typography>): 
              (
              <Typography variant="h5" color="primary">
              {t('step2title',{ns:'uploadvideo'})}:
              </Typography>)}
            </Grid>
            <Grid
              item
              xs={6}
            >
              <KeyboardDatePicker

                KeyboardButtonProps={{
                  'aria-label': 'change date',
                  onFocus: e => {
                    setDatePickerOpen(true);
                  }
                }}
                InputProps={{
                  onFocus: () => {
                    setDatePickerOpen(true);
                  }
                }}
                color="primary"
                disabled={
                  forUpdate|| savingStatus===SaveStatusTypes.SAVING
                }
                format={i18n.language=='en'? "MM/dd/yyyy": "dd/MM/yyyy"}
                label={t('datelabel',{ns:'uploadvideo'})}
                margin="normal"
                onChange={(event) => {
                  setDialogValue({ ...dialogValue, asmtdate: event as Date});
                  debugLog('Closing datepicker');
                  setDatePickerOpen(false);
                }
                }
                value={dialogValue.asmtdate}
                // defaultValue={null}
                
               //  onClick={()=>{setDatePickerOpen(true);}}
               // open={datePickerIsOpen}
              />
            </Grid>


            <Grid item md={12} sm={12} xs={12}>
              <FormControl
                fullWidth
                // mb={3}
              >
                <TextField 
                  id="notes"
                  color='primary'
                  label={t('step3notes',{ns:'uploadvideo'})}  
                  multiline
                  onChange={(event) => setDialogValue({ ...dialogValue, notes: event.target.value })}
                  placeholder={t('step3placeholder',{ns:'uploadvideo'})}
                  // rows={3}
                  // rowsMax={2}
                  value={dialogValue.notes}
                />
              </FormControl>
            </Grid>


        {(() => {
            // The "operative" Study ID is the one that actually governs whether
            // this upload will produce a report. Priority:
            //   (1) admin in manual-parent mode → look up the typed email
            //   (2) admin with an existing selected parent → that parent's ID
            //   (3) regular user → their own
            const isAdmin = cribsyUser.authLevel >= 5;
            let operativeStudyId = '';
            if (isAdmin && manualParentMode) {
              operativeStudyId = manualParentStudyId;
            } else if (isAdmin && currentSelectedParent != null) {
              operativeStudyId = selectedParentStudyId;
            } else {
              operativeStudyId = selfStudyId;
            }
            const enrolled = operativeStudyId !== '';

            return (
              <Grid container item md={12} sm={12} xs={12}>
                <FormControl>
                  {enrolled ? (
                    <>
                      <Typography variant='h5' style={{ color: '#2e7d32' }}>
                        {t('enrolledmsgtitle',{ns:'uploadvideo'})}
                      </Typography>
                      <Typography variant='caption'>
                        {t('enrolledmsg',{ns:'uploadvideo', studyid: operativeStudyId})}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography variant='h5' color='secondary'>
                        {t('studymsgtitle',{ns:'uploadvideo'})}:
                      </Typography>
                      <Typography variant='caption'>
                        {t('studymsg',{ns:'uploadvideo'})}
                      </Typography>
                    </>
                  )}
                </FormControl>
              </Grid>
            );
          })()}

            </Grid>
            </CardContent>            
            </Card>


        </DialogContent>
        

      </form>

    
    <Snackbar
        autoHideDuration={snackbarDuration}
        message = {toasterMessage} 
        onClose={handleToasterClose}
        open={toasterOpen}
      />
    </Dialog>
  );
}
